import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/campaign_reviews/show.vue'

export default class extends Controller {
  static values = {
    token: String
  }

  connect() {
    this.vue = createApp(App, { token: this.tokenValue })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
